/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import CreateClaimAction from './CreateClaimAction/index'
import CreateInvoiceAction from './CreateInvoiceAction/index'
import DueAmounts from './DueAmounts/index'
import Locations from './Locations/index'
import MoreAction from './MoreAction/index'
import Payors from './Payors/index'
import PostPaymentAction from './PostPaymentAction/index'
import React from 'react'
import Sort from './Sort/index'
import Treatments from './Treatments/index'
import ViewMode from './ViewMode/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-4-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-5-l16': dtColorsNeutral100,'--bbc-6-l16': dtColorsNeutral200,'--g-7-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Treatments
  viewPath={`${viewPath}/Treatments`}
/>
<Payors
  viewPath={`${viewPath}/Payors`}
/>
<div
  data-testid="New.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-7-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<PostPaymentAction
  viewPath={`${viewPath}/PostPaymentAction`}
/>
<CreateInvoiceAction
  viewPath={`${viewPath}/CreateInvoiceAction`}
/>
<CreateClaimAction
  viewPath={`${viewPath}/CreateClaimAction`}
/>
<MoreAction
  viewPath={`${viewPath}/MoreAction`}
/>
</div>
</div>
<div
  data-testid="New.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<DueAmounts
  viewPath={`${viewPath}/DueAmounts`}
/>
<div
  data-testid="New.Horizontal:2"
  data-view-path={viewPath}
 style={{'--pt-3-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-4-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-7-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<ViewMode
  viewPath={`${viewPath}/ViewMode`}
/>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
<Sort
  viewPath={`${viewPath}/Sort`}
/>
</div>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}